/* eslint-disable */
import { useEffect, useState } from 'react'
import { LogDetailsDialogProps } from '../../utils/interfaces'
import { fetchAccessLogs } from '../../apiCalls/alertsApi'
import { useApiGet } from '../../apiCalls/useApi'
import LogList from './LogList'

function LogListDialog({ appId, open, onClose, currentLogIds }: LogDetailsDialogProps) {
  const [logs, setLogs] = useState([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const fetchLogsData = useApiGet(fetchAccessLogs)

  useEffect(() => {
    const loadLogs = () => {
      if (!appId || !currentLogIds?.length) return

      setIsLoading(true)
      fetchLogsData({ appId, logIds: currentLogIds }).then((res: any) => {
        setLogs(res?.data || [])
      }).catch(e=>{
        setLogs([])
      }).finally(()=> setIsLoading(false))
    }

    if (open) {
      loadLogs()
    } else {
      setLogs([])
    }
  }, [appId, currentLogIds, open])

  return (
    <LogList
      open={open}
      onClose={onClose}
      logs={logs}
      isLoading={isLoading}
    />
  )
}

export default LogListDialog
